module.exports = __webpack_public_path__ + "media/dm-cancel.9842f89c.svg";